import _HOMApprovalService from "../services/hom-approval-service";
import { IHOMApprovalService } from "../types/services/hom-approval-service";

const instance = new _HOMApprovalService();

const HOMApprovalService: IHOMApprovalService = instance;

export default HOMApprovalService;
